import React from "react";
import { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';
import '../styles/LoginCss.css'
import TruveyBlackLogo from '../Asset/Images/XSO-Black.png';
import TruveyGreenLogo from '../Asset/Images/XSO-Green.png';
import { Avatar, Menu, MenuItem, Divider } from "@mui/material";

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const UserName = localStorage.getItem("UserName");
  const ProfileImageUrl = localStorage.getItem("ProfileUrl");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const UserRoleID=localStorage.getItem('RoleID');
  const UserType=localStorage.getItem('UserType');
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("JWTToken");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }

  }, []);

  // Handler to simulate logout
  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem("JWTToken");
    localStorage.removeItem("UserName");
    localStorage.removeItem("ProfileUrl");
    localStorage.removeItem("RoleID");
    localStorage.removeItem("UserEmail");
    localStorage.removeItem("UserType");
    navigate("/")
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <nav
        className="navbar navbar-light navbar-expand-lg fixed-top font-sanket shadow-sm"
        style={{ position: 'sticky', top: 0, backgroundColor: '#ffffff' }}>
        <div className="container p-md-0">
          {/* Logo */}
                <Link className="navbar-brand" to="/">
                  <img
                    src={TruveyGreenLogo}
                    alt="VRSamadhan"
                    width="110"
                    className="d-inline-block"
                  />
                </Link>
          {/* Navbar toggler for smaller screens */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="mb-0 ps-1 navbar-nav  align-items-center">
              {isLoggedIn ? (
                <>
                <li className="nav-item">
                  <Link className="nav-link" to="/SurveyList">
                    Survey List
                  </Link>
                </li>
                  {
                    UserRoleID !== "" ? (<>
                      {
                        (UserRoleID === "3" || UserRoleID === "4" || UserRoleID === "5") ? (<>
                          <li className="nav-item">
                            <Link className="nav-link" to="/AdminPanel">
                              Admin Panel
                            </Link>
                          </li>
                          {
                            (UserRoleID === "3") ? (<>
                              <Link className="nav-link" to="/CompanyPlans">
                              Company Plans
                              </Link>
                            </>) :
                             ("")
                          }
                        </>)
                          : (<>
                          </>)
                      }
                    </>) : (<></>)
                  }
                </>
              ) :
                <>
                </>
              }
            </ul>
            <ul className="navbar-nav ms-auto align-items-center">
              {/* Conditional Rendering Based on Login State */}
              {isLoggedIn ? (
                <>
                  {/* If the user is logged in */}
                  <li className="nav-item">
                    <span className="nav-link">Welcome, {UserName}</span>
                  </li>
                  <li className="nav-item">

                  </li>
                  <div>
                    <Avatar
                      src={ProfileImageUrl}
                      alt="Profile"
                      sx={{ width: 40, height: 40, cursor: "pointer" }}
                      onClick={handleClick}
                    />
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                      <MenuItem component={Link} to="/Profile" onClick={handleClose}>
                        Profile
                      </MenuItem>
                      {
                        UserType==="2"?(<>
                         <MenuItem component={Link} to={`/CompanyProfile`} onClick={handleClose}>
                          Company Profile
                        </MenuItem>
                        </>):(<></>)
                      }
                      <MenuItem onClick={handleClose}>Settings</MenuItem>
                      <Divider />
                      <MenuItem onClick={handleLogout} sx={{ color: "red" }}>
                        Sign Out
                      </MenuItem>
                    </Menu>
                  </div>
                  <li className="nav-item">

                  </li>
                </>
              ) : (
                <>
                  {/* If the user is not logged in */}
                  <li className="nav-item">
                    <Link className="nav-link active" to="/Login">
                      Login
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active" to="/SignUp">
                      Sign Up
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  )
}
export default Header;